import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import SVGIconWrapper from '../../Icons/SVGIconWrapper/SVGIconWrapper';
import { messageTypes } from '../../Includes/variables';
import GroupOverview from '../ChannelList/Channel/GroupOverview/GroupOverview';

import Icons from '../Icons/Icons';

import './Header.scss';
import UserImage from '../../Content/User/UserDisplay/UserImage/UserImage';

export class Header extends React.PureComponent {
    static propTypes = {
        /**
         * user's profile image
         */
        logo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        /**
         * user's username
         */
        name: PropTypes.string.isRequired,
        /**
         * user's role
         */
        title: PropTypes.string,
        /**
         * function that toggles on messages box's active state
         */
        onGoBack: PropTypes.func,
        /**
         * type of chat
         */
        type: PropTypes.oneOf(Object.values(messageTypes)),
        /**
         * group hash
         */
        hash: PropTypes.string,
    };

    static defaultProps = {
        type: messageTypes.COMMUNITY,
        onGoBack: () => {},
        hash: null,
    };

    checkMessagingLocation = () => {
        // returns true if we are NOT looking at a group page
        const pathname = this.props.location.pathname.toLowerCase();
        return !pathname.includes('group-chat');
    };

    onGroupGoBack = () => {
        if (this.props.location.state) {
            return this.props.history.goBack;
        }
        return () => (window.location = `/groups/${this.props.hash}/`);
    };

    onGoBack = (isMessagePage) => {
        if (this.props.type !== messageTypes.GROUP) {
            return this.props.onGoBack;
        }
        return isMessagePage ? this.props.onGoBack : this.onGroupGoBack();
    };

    renderGoBack = (isMessagePage) => {
        const svgClassName = isMessagePage ? 'direct-message' : 'group-message';

        return (
            <SVGIconWrapper
                handleClickSVGWrapper={this.onGoBack(isMessagePage)}
                SVGWrapperCssClass={`back-caret ${svgClassName}`}
            >
                <Icons name="back-caret" />
            </SVGIconWrapper>
        );
    };

    communityHeader = () => {
        const isMessagePage = this.checkMessagingLocation();
        return (
            <React.Fragment>
                {this.renderGoBack(isMessagePage)}
                <UserImage
                    image={{
                        src: this.props.logo,
                        alt: `${this.props.name}-logo`,
                    }}
                    className={'user-profile-icon'}
                    iconSize={36}
                />
                <div className="user-info">
                    <span className="username">{this.props.name}</span>
                    <span className="user-title">{this.props.title}</span>
                </div>
            </React.Fragment>
        );
    };

    groupHeader = () => {
        const isMessagePage = this.checkMessagingLocation();
        const overviewClassName = isMessagePage
            ? 'group-overview'
            : 'group-page-header-overview';
        const displayData = { logo: this.props.logo, name: this.props.name };

        return (
            <React.Fragment>
                {!isMessagePage && (
                    <div className="group-chat-header">
                        {this.renderGoBack(isMessagePage)}
                        <div className={'title'}>Group Chat Room</div>
                    </div>
                )}

                <div className="group-chat-details">
                    {isMessagePage && this.renderGoBack(isMessagePage)}
                    <GroupOverview
                        className={overviewClassName}
                        displayData={displayData}
                        shouldShowUnreadCount={false}
                    />
                </div>
            </React.Fragment>
        );
    };

    getHeader = () => {
        switch (this.props.type) {
            case messageTypes.GROUP:
                return this.groupHeader();
            default:
                return this.communityHeader();
        }
    };

    render() {
        const groupHeaderClassName = this.checkMessagingLocation()
            ? ''
            : 'group';

        return (
            <div
                className={`component-Messages-Header ${groupHeaderClassName}`}
            >
                {this.getHeader()}
            </div>
        );
    }
}

export default withRouter(Header);
